document.addEventListener('DOMContentLoaded', () => {
  initAboutLocation();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.about-location')) {
      initAboutLocation();
    }
  });
});

function initAboutLocation() {
  const sections = document.querySelectorAll('.about-location');

  sections.forEach((section) => {
    const maxScale = parseFloat(section.dataset.scrollScale) || 15;
    const mapEl = section.querySelector('.about-location__map');
    const mediaEl = section.querySelector('.about-location__media');
    let isVisible = false;

    if (!mapEl && !mediaEl) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;
        });
      },
      { threshold: 0 }
    );

    observer.observe(section);

    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!isVisible) return;
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const rect = section.getBoundingClientRect();
        const sectionHeight = section.offsetHeight;
        const viewportHeight = window.innerHeight;
        const totalTravel = sectionHeight + viewportHeight;
        const traveled = viewportHeight - rect.top;
        const progress = Math.max(0, Math.min(1, traveled / totalTravel));

        const scaleValue = 1 + (maxScale / 100) * progress;

        if (mapEl) {
          mapEl.style.setProperty('--map-scale', scaleValue);
        }
        if (mediaEl) {
          mediaEl.style.setProperty('--photo-scale', scaleValue);
        }

        ticking = false;
      });
    });
  });
}
